let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4ryKW")).then(() => parcelRequire('4o595'));